import { InputBaseType } from '@/components/ReportForm/InputBase/types';
import { useTranslation } from '@/i18n';
import {
  FormInput,
  FormInputProps,
} from '@moneyforward/ap-frontend-components';
import { memo, useMemo } from 'react';
import { FieldValues } from 'react-hook-form';
import { PAYEE_FORM_MAX_LENGTH } from '../constants';

export type Props<TFieldValues extends FieldValues> = Omit<
  InputBaseType<TFieldValues>,
  'label' | 'tooltip' | 'caption' | 'hidden'
> &
  FormInputProps<TFieldValues> & {
    maxLength?: number;
  };

const InnerApPayeeFormInputContactPersonName = <
  TFieldValues extends FieldValues
>({
  control,
  name,
  inputId,
  required = false,
  maxLength = PAYEE_FORM_MAX_LENGTH.CONTACT_PERSON_NAME,
  ...rest
}: Props<TFieldValues>) => {
  const { t } = useTranslation();

  const rules = useMemo(
    () => ({
      required: required ? t('required') : false,
      maxLength: {
        value: maxLength,
        message: t('ap_payee_contact_person_name_max_error', {
          maxLength: maxLength,
        }),
      },
    }),
    [required, t, maxLength]
  );

  return (
    <FormInput<TFieldValues>
      control={control}
      name={name}
      inputId={inputId}
      rules={rules}
      {...rest}
    />
  );
};

InnerApPayeeFormInputContactPersonName.displayName =
  'InnerApPayeeFormInputContactPersonName';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const ApPayeeFormInputContactPersonName = memo((props) => (
  <InnerApPayeeFormInputContactPersonName {...props} />
)) as typeof InnerApPayeeFormInputContactPersonName;
ApPayeeFormInputContactPersonName.displayName =
  'ApPayeeFormInputContactPersonName';
